import { useQuery } from '@tanstack/react-query';
import { useTacticHooks } from '../../providers/TacticHooksProvider';

export interface UseResourcesOptions {
  officeId: string | null;
  types?: string[];
  parentId?: string;
  manage?: boolean;
  hierarchy?: boolean;
  /**
   * When provided, the resource's visible assignments are returned for this
   * date (format: yyyy-MM-dd). Used by the map to show assignments.
   */
  assignmentsDate?: string | null;
}

export function useResources(
  {
    officeId,
    types = ['workspace', 'desk', 'meeting_room'],
    parentId,
    manage = false,
    hierarchy = false,
    assignmentsDate = null
  }: UseResourcesOptions,
  {
    enabled = true
  }: {
    enabled?: boolean;
  } = {
    enabled: true
  }
) {
  const { api } = useTacticHooks();
  types.sort();
  const { data: resources, error, refetch } = useQuery({
    queryKey: [
      'organizations.resourcesAll',
      officeId!,
      types,
      parentId ? parentId : null,
      manage,
      hierarchy,
      assignmentsDate
    ],

    queryFn: async () => {
      if (manage) {
        const res = await api.client.organizations.resourcesAll(
          officeId!,
          types,
          parentId ? parentId : null,
          null,
          true,
          null,
          null,
          null,
          undefined,
          hierarchy,
          manage
        );
        return res.result;
      }

      const res = await api.client.organizations.getAllResources({
        officeId: officeId!,
        types,
        parentId: parentId ? parentId : null,
        assignments_date: assignmentsDate
      });

      return res.result;
    },

    enabled: enabled && officeId !== null
  });

  const loading = !resources && !error;
  return { resources, error, loading, refetch };
}
